exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".training-page-header.page-heading{background:transparent!important;border-bottom:0!important;padding:20px 10px 0!important}.training-page-header.page-heading>.col-lg-12{padding-left:0!important;padding-right:0!important}.training-page-header.page-heading h2{display:flex;align-items:center;width:100%;min-height:64px;margin:0 0 12px;padding:12px 16px;background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:15px}.training-page.wrapper.wrapper-content{padding-left:10px;padding-right:10px}.training-booking-card{border:1px solid rgba(0,0,0,.08);border-radius:15px;overflow:hidden}.training-booking-card .ibox-title{border-top-left-radius:15px;border-top-right-radius:15px}.training-booking-card .ibox-content{border-bottom-left-radius:15px;border-bottom-right-radius:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/training/training.book.component.css
// module id = 1249
// module chunks = 0